import { debug } from '../utils/debug';

// Debug log all environment variables
debug.log('All Environment Variables:', {
  REACT_APP_GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  REACT_APP_GOOGLE_MAPS_MAP_ID: process.env.REACT_APP_GOOGLE_MAPS_MAP_ID,
  NODE_ENV: process.env.NODE_ENV
});

// Ensure mapId is always an array
const mapId = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID;
const mapIds = mapId ? [mapId] : [];

export const GOOGLE_MAPS_CONFIG = {
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  mapIds: mapIds,
  libraries: ['maps', 'marker', 'places', 'geocoding'],
  version: 'beta'
};

debug.log('Google Maps Config:', {
  ...GOOGLE_MAPS_CONFIG,
  apiKey: GOOGLE_MAPS_CONFIG.apiKey ? 'Set' : 'Not Set',
  mapIds: GOOGLE_MAPS_CONFIG.mapIds
});

export const MAP_CONTAINER_STYLE = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0
};

export const MAP_DEFAULTS = {
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: false,
  zoom: 12
}; 